/* import __COLOCATED_TEMPLATE__ from './modal.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import templateOnlyComponent from '@ember/component/template-only';
interface Signature {
  Args: {
    isOpen: boolean;
    onModalClose: (object: string) => void;
  };
}

const ReferralModal = templateOnlyComponent<Signature>();
export default ReferralModal;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Referral::Modal': typeof ReferralModal;
    'referral/modal': typeof ReferralModal;
  }
}
